module.exports = __webpack_public_path__ + "static/media/SBD_01.0d8b3dea.jpeg";